import state from './modifierState'
import mutations from './modifierMutations'
import actions from './modifierActions'
import getters from './modifierGetters'

export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
